import { Platform } from 'react-native';
import * as Notifications from 'expo-notifications';
import * as TaskManager from 'expo-task-manager';
import { auth } from '@/lib/firebase';
import {
  refreshAppleTripSurfaceSnapshot,
  shouldRefreshTripSurfaceForNotification,
} from '@/services/appleTripSurfaceBackgroundRefresh';

export const APPLE_TRIP_SURFACE_BACKGROUND_TASK = 'apple-trip-surface-background-sync';

TaskManager.defineTask(APPLE_TRIP_SURFACE_BACKGROUND_TASK, async ({ data, error }) => {
  if (error || Platform.OS !== 'ios') {
    return;
  }

  const payload = data as Notifications.NotificationTaskPayload | undefined;
  const notificationData = payload?.notification?.request?.content?.data as
    | Record<string, unknown>
    | undefined;

  if (!shouldRefreshTripSurfaceForNotification(notificationData)) {
    return;
  }

  const userId = auth.currentUser?.uid;
  if (!userId) {
    return;
  }

  const tripId =
    typeof notificationData?.tripId === 'string' ? notificationData.tripId : undefined;

  await refreshAppleTripSurfaceSnapshot({
    userId,
    tripId,
    preferNetwork: true,
    fromServer: true,
  });
});

let backgroundTaskRegistered = false;

export const registerAppleTripSurfaceBackgroundTask = async (): Promise<void> => {
  if (Platform.OS !== 'ios' || backgroundTaskRegistered) {
    return;
  }

  try {
    await Notifications.registerTaskAsync(APPLE_TRIP_SURFACE_BACKGROUND_TASK);
    backgroundTaskRegistered = true;
  } catch (error) {
    console.warn('[AppleTripSurface] Failed to register background notification task', error);
  }
};

export const handleTripSurfaceNotificationReceived = (
  data: Record<string, unknown> | undefined,
): void => {
  if (Platform.OS !== 'ios' || !shouldRefreshTripSurfaceForNotification(data)) {
    return;
  }

  const userId = auth.currentUser?.uid;
  if (!userId) {
    return;
  }

  const tripId = typeof data?.tripId === 'string' ? data.tripId : undefined;
  void refreshAppleTripSurfaceSnapshot({
    userId,
    tripId,
    preferNetwork: true,
    fromServer: true,
  });
};
